import { type ContainerParameters } from "./ActionRecord";

export const parseContainerParameters = (
  command: string | undefined,
  entrypoint: string | undefined,
  workdir: string | undefined,
  envVars: Record<string, string> | undefined,
) => {
  const containerParameters = {} as ContainerParameters;

  const hasEnvVars = envVars && Object.keys(envVars).length > 0;
  if (!command && !entrypoint && !workdir && !hasEnvVars) {
    return null;
  }

  if (command !== undefined) {
    containerParameters.command = transformCommand(command, false);
  } else {
    containerParameters.command = null;
  }

  if (entrypoint !== undefined) {
    if (entrypoint === "null" || entrypoint === "") {
      containerParameters.entry_point = null;
    } else {
      containerParameters.entry_point = [entrypoint];
    }
  } else {
    containerParameters.entry_point = null;
  }

  if (workdir !== undefined) {
    if (workdir === "null") {
      containerParameters.workdir = null;
    } else {
      containerParameters.workdir = workdir;
    }
  }

  if (hasEnvVars) {
    containerParameters.env_vars = envVars;
  }

  return containerParameters;
};

export const stringifyCommand = (commandArr: string[] | null) => {
  if (commandArr === null) {
    return "null";
  }
  if (commandArr) {
    return commandArr.join(",");
  } else {
    return undefined;
  }
};

export const transformCommand = (
  commandStr: string,
  includeQuotes: boolean,
): string[] | null => {
  if (commandStr === "null" || commandStr === "") {
    return null;
  }
  if (includeQuotes) {
    return commandStr.split(",").map((chunk) => `"${chunk.trim()}"`);
  }

  return commandStr.split(",").map((chunk) => `${chunk.trim()}`);
};
